export default __webpack_public_path__ + "static/media/scythe.390cea32.png";